import styled from 'styled-components';
import Ico20 from '../Ico20';
import { Typ20 } from '../Typ';
import ToolTip01 from '../ToolTip01';
import Btn020 from '../Btn020';

export const SectionHeaderWrapper = styled.div`
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => (props.color ? props.color : '#689f38')};
  padding: 0 12px;
`;

export const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Icon = styled(Ico20)`
  margin-right: 8px;
  color: #fff;
`;

export const TextToolTip = styled(ToolTip01)`
  div div {
    width: 237px;
    margin-left: -17px;
    margin-top: 17px;
  }
`;

export const ButtonToolTip = styled(ToolTip01)`
  div div {
    width: 237px;
    margin-left: -68px;
    margin-top: 21px;
  }
`;

export const Text = styled(Typ20)`
  color: #fff;
`;

export const Button = styled(Btn020)`
  span {
    color: #fff;
  }
  &:hover {
    span {
      opacity: 0.7;
    }
  }
  &:active {
    span {
      opacity: 0.7;
    }
  }
`;
